import { da } from "date-fns/locale"
import api from "./api"

export const getAllAccounts = () => {
  return api.get("/accounts")
}

export const getAllPositions = () => {
  return api.get("/positions")
}

export const getAllGroups = () => {
  return api.get("/groups")
}

export const getAllSummaries = (currency: string) => {
  return api.get(`/summary?currency=${currency}`);
};

export const getAllOrders = () => {
  return api.get("/orders")
}

export const getConnections = () => {
  return api.get("/connections")
}

export const getAccount = (login: number | string) => {
  return api.get("/account?login=" + login);
};

export const getAccountPermissions = (login: number | string) => {
  return api.get("/account-rights?login=" + login);
};

export const getTradeHistoryOfAllUsers = (from: string, to: string) => {
  if (!from || !to) return Promise.reject();

  return api.get(`/commission-summary?from=${from}&to=${to}`);
};

export const getTradeHistory = (login: number, from: string, to: string) => {
  if (!from || !to) return Promise.reject();

  return api.get(`/trades-history?login=${login}&from=${from}&to=${to}`);
};

export const getIpAddressService = (from: string, to: string) => {
  if (!from || !to) return Promise.reject();

  return api.get(`/ip-address?from=${from}&to=${to}`);
};

export const createTransaction = (
  login: number,
  amount: number,
  type: number,
  comment: string = ""
) => {
  const bodyFormData = new FormData();
  bodyFormData.append("login", `${login}`);
  bodyFormData.append("amount", `${amount}`);
  bodyFormData.append("type", `${type}`);

  if (comment) {
    bodyFormData.append("comment", `${comment}`);
  }

  return api.post("/transaction", bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const changePassword = (data: any) => {
  const bodyFormData = new FormData();
  bodyFormData.append("login", data?.login);
  bodyFormData.append("type", data?.type);
  bodyFormData.append("password", data?.password);

  return api.post("/change-password", bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updatePermissions = (login: any, permissions: any[]) => {
  const bodyFormData = new FormData();

  bodyFormData.append("login", login);

  permissions.forEach((p) => {
    bodyFormData.append(p?.key, p?.value);
  });

  return api.post("/update-account-rights", bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};



export const changeGroupService = (data: any) => {
  const bodyFormData = new FormData();
  bodyFormData.append("login", data?.login);
  bodyFormData.append("group", data?.group);

  return api.post("/change-group", bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const createUser = (data: any) => {
  const bodyFormData = new FormData();
  bodyFormData.append("group", `${data?.group}`);
  bodyFormData.append("leverage", `${data?.leverage}`);
  bodyFormData.append("f_name", `${data?.f_name}`);
  bodyFormData.append("l_name", `${data?.l_name}`);
  bodyFormData.append("master_password", `${data?.master_password}`);
  bodyFormData.append("investor_password", `${data?.investor_password}`);

  if (data?.login) {
    bodyFormData.append("login", `${data?.login}`);
  }

  if (data?.email) {
    bodyFormData.append("email", `${data?.email}`);
  }

  if (data?.phone) {
    bodyFormData.append("phone", `${data?.phone}`);
  }
  if (data?.company) {
    bodyFormData.append("company", `${data?.company}`);
  }
  if (data?.country) {
    bodyFormData.append("country", `${data?.country}`);
  }
  if (data?.zipcode) {
    bodyFormData.append("zipcode", `${data?.zipcode}`);
  }
  if (data?.state) {
    bodyFormData.append("state", `${data?.state}`);
  }
  if (data?.city) {
    bodyFormData.append("city", `${data?.city}`);
  }
  if (data?.address) {
    bodyFormData.append("address", `${data?.address}`);
  }

  return api.post("/create-user", bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getAllDepositsAndWithdrawalOfAUser = (
  from?: string,
  to?: string,
  login?: string,
  type?: number
) => {
  console.log(from, to, login);

  if (!from || !to) return Promise.reject();

  let query = `?from=${from}&to=${to}`;

  if (login) {
    query += `&login=${login}`;
  }

  if (type) {
    query += `&type=${type}`;
  }

  return api.get(`/login-wise-deposits-and-withdrawals${query}`);
};

export const getDailyReportOfAUser = (
  from?: string,
  to?: string,
  login?: string
) => {
  if (!from || !to) return Promise.reject();

  let query = `?from=${from}&to=${to}`;

  if (login) {
    query += `&login=${login}`;
  }

  return api.get(`/daily?login=${login}&from=${from}&to=${to}&login=${login}`);
};

export const getDealsHistory = (from?: string, to?: string, login?: string) => {
  if (!from || !to) return Promise.reject();

  let query = `?from=${from}&to=${to}`;

  if (login) {
    query += `&login=${login}`;
  }

  return api.get(`/deals-history${query}`);
};

export const getOrdersHistory = (
  from?: string,
  to?: string,
  login?: string
) => {
  if (!from || !to) return Promise.reject();

  let query = `?from=${from}&to=${to}`;

  if (login) {
    query += `&login=${login}`;
  }

  return api.get(`/order-history${query}`);
};

export const updateUser = (data: any) => {
  const bodyFormData = new FormData();
  bodyFormData.append("login", data?.login);
  bodyFormData.append("f_name", data?.f_name);
  bodyFormData.append("m_name", data?.m_name);
  bodyFormData.append("l_name", data?.l_name);
  bodyFormData.append("color", data?.color);

  bodyFormData.append("email", data?.email ?? "");
  bodyFormData.append("phone", data?.phone ?? "");
  bodyFormData.append("company", data?.company ?? "");
  bodyFormData.append("country", data?.country ?? "");
  bodyFormData.append("zipcode", data?.zipcode ?? "");
  bodyFormData.append("state", data?.state ?? "");
  bodyFormData.append("city", data?.city ?? "");
  bodyFormData.append("address", data?.address ?? "");

  return api.post("/update-user", bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};